import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import type { ListKeys } from '@src/constants/microcredits';
import { sendPaginationEvent } from '@src/helpers/analyticsEvents';
import { useAbSeaExperiment } from '@src/hooks/useAbSeaExperiment';
import { fetchMoreOffersAB } from '@src/reducers/microcredits';
import { MoreButton } from 'entities/ProductList/ui/MoreButton';

interface IProps {
  className?: string;
  listKey: ListKeys;
  preloadTotal: number;
  loadItemCount: number;
}

export const ShowMoreButton: React.FC<IProps> = memo(({ listKey, preloadTotal, className }) => {
  const dispatch = useDispatch();
  const features = useAbSeaExperiment();

  const handleClickLoadMore = useCallback(() => {
    sendPaginationEvent();
    dispatch(fetchMoreOffersAB({ key: listKey, features }));
  }, [dispatch, listKey, features]);

  return <MoreButton className={className} text={`Показать еще ${preloadTotal}`} onClick={handleClickLoadMore} />;
});
